import React from 'react';

function HeroDashboard() {
  return (
    <div className="hero-dashboard" aria-hidden="true">
      <div className="hero-dashboard__titlebar">
        <span className="hero-dashboard__app-dot" style={{ background: '#ff5f57' }} />
        <span className="hero-dashboard__app-dot" style={{ background: '#febc2e' }} />
        <span className="hero-dashboard__app-dot" style={{ background: '#28c840' }} />
        <span className="hero-dashboard__window-title">TechSoul Work</span>
      </div>

      <div className="hero-dashboard__body">
        <div className="hero-dashboard__greeting">
          <div className="hero-dashboard__greeting-row">
            <span className="hero-dashboard__greeting-text">Guten Abend, Chris</span>
            <span className="hero-dashboard__gear">⚙️</span>
          </div>
          <span className="hero-dashboard__date">Donnerstag, 18. Juni</span>
          <span className="hero-dashboard__briefing">Briefing aktualisiert vor 2 Min. · ↻ Aktualisieren</span>
        </div>

        <div className="hero-dashboard__grid">
          <div className="hero-dashboard__card">
            <div className="hero-dashboard__card-header">
              <span>🎯 FOKUS HEUTE</span>
              <span className="hero-dashboard__badge">1</span>
            </div>
            <div className="hero-dashboard__card-row">
              <span>Analyse</span>
              <span className="hero-dashboard__meta">Heute</span>
            </div>
          </div>
          <div className="hero-dashboard__card">
            <div className="hero-dashboard__card-header"><span>⏳ WARTET AUF ANTWORT</span></div>
            <div className="hero-dashboard__card-empty">✓ Keine offenen Rückmeldungen</div>
          </div>
          <div className="hero-dashboard__card">
            <div className="hero-dashboard__card-header"><span>🚨 KRITISCHE PUNKTE</span></div>
            <div className="hero-dashboard__card-empty">✓ Nichts Kritisches offen</div>
          </div>
          <div className="hero-dashboard__card">
            <div className="hero-dashboard__card-header"><span>👥 DELEGATION</span></div>
            <div className="hero-dashboard__card-empty">✓ Alle delegierten Aufgaben erledigt</div>
          </div>
        </div>

        <div className="hero-dashboard__card">
          <div className="hero-dashboard__card-header">
            <span>📅 NÄCHSTE TERMINE</span>
            <span className="hero-dashboard__badge">1</span>
          </div>
          <div className="hero-dashboard__card-row">
            <span>Planungsrunde</span>
            <span className="hero-dashboard__meta">in 3 Tagen</span>
          </div>
        </div>

        <div className="hero-dashboard__card">
          <div className="hero-dashboard__card-header">
            <span>💡 NEUE ERKENNTNISSE AUS MEETINGS</span>
            <span className="hero-dashboard__badge">2</span>
          </div>
          <div className="hero-dashboard__meeting">
            <span className="hero-dashboard__meeting-title">
              Team-Meeting
              <span className="hero-dashboard__meeting-date">17. Juni</span>
            </span>
            <div className="hero-dashboard__chips">
              <span className="hero-dashboard__chip hero-dashboard__chip--cyan">6 Aufgaben</span>
              <span className="hero-dashboard__chip hero-dashboard__chip--blue">4 Entscheidungen</span>
              <span className="hero-dashboard__chip hero-dashboard__chip--green">5 Erkenntnisse</span>
            </div>
          </div>
        </div>

        <div className="hero-dashboard__coach">
          <span className="hero-dashboard__coach-label">💬 COACH FRAGEN</span>
          <div className="hero-dashboard__coach-btns">
            <span className="hero-dashboard__coach-btn">Was steht heute an?</span>
            <span className="hero-dashboard__coach-btn">Was habe ich vergessen?</span>
            <span className="hero-dashboard__coach-btn">Wo muss ich nachfassen?</span>
          </div>
          <div className="hero-dashboard__coach-form">
            <span className="hero-dashboard__coach-input">Eigene Frage stellen…</span>
            <span className="hero-dashboard__coach-send">Fragen →</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function Hero() {
  return (
    <section className="hero">
      <HeroDashboard />

      <div className="hero-content">
        <p className="hero-eyebrow">Leadership Operating System</p>
        <h1>
          Weniger Chaos.<br />
          Mehr Klarheit.<br />
          <span className="highlight">Bessere Entscheidungen.</span>
        </h1>
        <p className="hero-sub">
          KI-gestütztes Führungssystem für Teamleiter, Projektleiter, Bereichsleiter und Operations Manager.
        </p>
        <p className="hero-desc">
          TechSoul hilft dabei, Aufgaben zu delegieren, Verantwortlichkeiten nachzuverfolgen,
          Entscheidungen zu dokumentieren und Wissen dauerhaft verfügbar zu machen.
        </p>
        <div className="hero-ctas">
          <a href="#work" className="cta-button cta-button--work cta-button--primary">
            🚀 TechSoul Work entdecken
          </a>
          <a href="#life" className="cta-button cta-button--life cta-button--secondary">
            ✨ TechSoul Life
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
